import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/specialist";

export const getAllSpecialist = () => axios.get(API_PATH + "/get-all");

export const pagingSpecialist = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getSpecialistById = (specialistId) => axios.get(API_PATH + "/get-by-id/" + specialistId);

export const saveSpecialist = specialist => axios.post(API_PATH + '/save', specialist);
 
export const deleteSpecialist = specialistId => axios.delete(API_PATH + '/mark-delete/' + specialistId)
